import { Col, Form, Input, PageHeader, Row, Typography } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { FiscalType } from "shared/enums/FiscalType";
import { getI18nCoutry } from "shared/helpers/i18nCountry";
import { Team } from "shared/interfaces/Team";
import { Modal } from "shared/components";
import { CalendarOutlined } from "@ant-design/icons";
import "./TeamManagement.scss";

interface TeamDetailsProps {
  team?: Team;
}
const TeamDetails: React.FC<TeamDetailsProps> = (props) => {
  const { team } = props;
  const { t, i18n } = useTranslation("radar");
  const [form] = Form.useForm();
  const [showModal, setShowModal] = useState<boolean>(false);
  const countries = useSelector((state: any) => state.countries.countries);
  const contactMail = process.env.REACT_APP_SUPORT_MAIL;
  const birthDate = team?.birthDate
    ? new Date(team.birthDate).toLocaleDateString()
    : "";

  const fiscalTypes = [
    t("pages.TeamManagement.undefined"),
    t("pages.TeamManagement.fiscalPerson"),
    t("pages.TeamManagement.fiscalEntity"),
  ];
  const fiscalType = fiscalTypes[team?.fiscalType || 0];
  const wrappGetI18nGenre = (genre: string) =>
    getI18nCoutry(genre, i18n, countries);
  const country = wrappGetI18nGenre(team?.country || "");

  useEffect(() => {
    form.resetFields();
  }, [team, form]);

  return (
    <>
      <Row justify="center">
        <Col xs={24}>
          <PageHeader
            title={t("pages.TeamManagement.details")}
            extra={[
              <button
                className="botao-vazado"
                onClick={() => setShowModal(true)}
              >
                {t("pages.TeamManagement.noFix")}
              </button>,
            ]}
          />
          <Row justify="center">
            <Col xs={18}>
              <Form
                layout="horizontal"
                form={form}
                initialValues={team}
                style={{ color: "#fff" }}
              >
                <Row gutter={32}>
                  <Col xs={6}>
                    <span className="label">
                      {t("pages.TeamManagement.fiscalType")}
                    </span>
                  </Col>
                  <Col xs={12}>
                    <Form.Item>
                      <Input
                        disabled
                        value={fiscalType}
                        style={{
                          color: "#E4BC5C",
                          background: "#1F1F1F",
                          borderColor: "transparent",
                        }}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                {team?.fiscalType === FiscalType.PessoaJuridica && (
                  <>
                    <Row gutter={32}>
                      <Col xs={6}>
                        <span className="label">
                          {t("pages.TeamManagement.companyName")}
                        </span>
                      </Col>
                      <Col xs={12}>
                        <Form.Item name="name">
                          <Input disabled />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row gutter={32}>
                      <Col xs={6}>
                        <span className="label">
                          {t("pages.TeamManagement.businessName")}
                        </span>
                      </Col>
                      <Col xs={12}>
                        <Form.Item name="businessName">
                          <Input disabled />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row gutter={32}>
                      <Col xs={6}>
                        <span className="label">
                          {t("pages.TeamManagement.cnpj")}
                        </span>
                      </Col>
                      <Col xs={12}>
                        <Form.Item name="cnpj">
                          <Input disabled />
                        </Form.Item>
                      </Col>
                    </Row>
                  </>
                )}
                {team?.fiscalType === FiscalType.PessoaFisica && (
                  <>
                    <Row gutter={32}>
                      <Col xs={6}>
                        <span className="label">
                          {t("pages.TeamManagement.personName")}
                        </span>
                      </Col>
                      <Col xs={12}>
                        <Form.Item name="name">
                          <Input disabled />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row gutter={32}>
                      <Col xs={6}>
                        <span className="label">
                          {t("pages.TeamManagement.birthDate")}
                        </span>
                      </Col>
                      <Col xs={12}>
                        <Form.Item>
                          <Input
                            disabled
                            value={birthDate}
                            addonAfter={<CalendarOutlined />}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row gutter={32}>
                      <Col xs={6}>
                        <span className="label">
                          {t("pages.TeamManagement.cpf")}
                        </span>
                      </Col>
                      <Col xs={12}>
                        <Form.Item name="cpf">
                          <Input disabled />
                        </Form.Item>
                      </Col>
                    </Row>
                  </>
                )}
                <Row gutter={32}>
                  <Col xs={6}>
                    <span className="label">
                      {t("pages.TeamManagement.phone")}
                    </span>
                  </Col>
                  <Col xs={12}>
                    <Form.Item name="phone">
                      <Input disabled />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={32}>
                  <Col xs={6}>
                    <span className="label">
                      {t("pages.TeamManagement.country")}
                    </span>
                  </Col>
                  <Col xs={12}>
                    <Form.Item>
                      <Input disabled value={country} />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={32}>
                  <Col xs={6}>
                    <span className="label">
                      {t("pages.TeamManagement.state")}
                    </span>
                  </Col>
                  <Col xs={12}>
                    <Form.Item name="state">
                      <Input disabled />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={32}>
                  <Col xs={6}>
                    <span className="label">
                      {t("pages.TeamManagement.city")}
                    </span>
                  </Col>
                  <Col xs={12}>
                    <Form.Item name="city">
                      <Input disabled />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={32}>
                  <Col xs={6}>
                    <span className="label">
                      {t("pages.TeamManagement.postalCode")}
                    </span>
                  </Col>
                  <Col xs={12}>
                    <Form.Item name="postalCode">
                      <Input disabled />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={32}>
                  <Col xs={6}>
                    <span className="label">
                      {t("pages.TeamManagement.address")}
                    </span>
                  </Col>
                  <Col xs={12}>
                    <Form.Item name="address">
                      <Input disabled />
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            </Col>
          </Row>
        </Col>
      </Row>
      <Modal
        onCancel={() => setShowModal(false)}
        visible={showModal}
        showCancelButton={false}
        showOkButton={false}
        width={"50%"}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "start",
          }}
        >
          <Typography.Text style={{ fontSize: 16, color: "#E4BC5C" }}>
            {t("pages.TeamManagement.updateInfo")}
          </Typography.Text>
          <Typography.Text style={{ fontSize: 20, color: "#fff" }}>
            {t("pages.TeamManagement.updateQuestion")}
          </Typography.Text>

          <Typography.Text style={{ fontSize: 20, color: "#fff" }}>
            <a style={{ color: "#E4BC5C" }} href={`mailto:${contactMail}`}>
              {t("pages.TeamManagement.clickHere")}
            </a>
            {t("pages.TeamManagement.updateMessage")}
          </Typography.Text>
        </div>
      </Modal>
    </>
  );
};

export default TeamDetails;
